var _g, _g2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSortDesc({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "#0D6EFD",
    width: "800px",
    height: "800px",
    viewBox: "0 0 64 64",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlSpace: "preserve",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      strokeLinejoin: "round",
      strokeMiterlimit: 2
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_bgCarrier",
    strokeWidth: 0
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_tracerCarrier",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_iconCarrier"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,-1152,-320)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Icons",
    x: 0,
    y: 0,
    width: 1280,
    height: 800,
    style: {
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,64,0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "caret-down",
    transform: "matrix(0.522955,0.522955,-0.525161,0.525161,1082.79,109.448)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M288,216L256,216L256,212L284,212L284,184L288,184L288,216Z",
    style: {
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "caret-down1",
    transform: "matrix(-0.522955,-0.522955,0.525161,-0.525161,1157.21,594.552)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M288,216L256,216L256,212L284,212L284,184L288,184L288,216Z",
    style: {
      fill: "#d9d9d9",
      fillRule: "nonzero"
    }
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSortDesc);
export default __webpack_public_path__ + "static/media/sortDesc.f6d51dbb1612ab033269065f9d19ee6f.svg";
export { ForwardRef as ReactComponent };